
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const EnterprisePage = lazy(() => import('../pages/enterprise/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/enterprise',
    element: <EnterprisePage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
